import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import app from '../../main' // import the instance
import checkResponse from '@/utils/checkResponse'
import parserFilters from '@/utils/parserFilters'
import parserSlug from '@/utils/parserSlug'

Vue.use(Vuex)

const state = {
  purchaseRequisitions: [],
  purchaseRequisition: {
    details: []
  },
  pagination: {
    currentPage: 1,
    perPage: 5,
    amountPurchaseRequisitions: 0,
    totalPages: 0
  },
  purchaseRequisitionsCatalog: {
    units_measurement: [],
    users: [],
    inventories: []
  },
  filterParams: '',
  isModalVisible: false,
  isModalPropVisible: false
}

const mutations = {
  INIT_PURCHASE_REQUISITION_DETAIL (state, payload) {
    state.purchaseRequisition = payload
  },
  SET_PURCHASE_REQUISITIONS (state, payload) {
    state.purchaseRequisitions = payload.data

    state.pagination = {
      currentPage: payload.current_page,
      perPage: payload.per_page,
      amountPurchaseRequisitions: payload.amount,
      totalPages: payload.last_page
    }
  },
  ADD_PURCHASE_REQUISITION (state, payload) {
    state.purchaseRequisitions.unshift(payload)
  },
  UPDATE_PURCHASE_REQUISITION (state, payload) {
    state.purchaseRequisition = payload
  },
  UPDATE_PURCHASE_REQUISITION_ACTION (state, payload) {
    const idx = state.purchaseRequisitions.findIndex(u => u.id === payload.id)

    if (idx >= 0) {
      Vue.set(state.purchaseRequisitions, idx, payload)
    }
  },
  DELETE_PURCHASE_REQUISITION (state, payload) {
    const idx = state.purchaseRequisitions.findIndex(u => u.id === payload.id)

    if (idx >= 0) {
      Vue.delete(state.purchaseRequisitions, idx)
    }
  },
  DELETE_PURCHASE_REQUISITIONS (state, payload) {
    for (let id of payload.ids) {
      const idx = state.purchaseRequisitions.findIndex(u => u.id === id)

      if (idx >= 0) {
        Vue.delete(state.purchaseRequisitions, idx)
      }
    }
  },
  ADD_PURCHASE_REQUISITION_DETAIL (state, payload) {
    state.purchaseRequisition.details.push(payload)
  },
  UPDATE_PURCHASE_REQUISITION_DETAIL (state, { payload, idx }) {
    if (idx >= 0) {
      Vue.set(state.purchaseRequisition.details, idx, payload)
    }
  },
  DELETE_PURCHASE_REQUISITION_DETAIL (state, idx) {
    if (idx >= 0) {
      Vue.delete(state.purchaseRequisition.details, idx)
    }
  },
  DELETE_PURCHASE_REQUISITION_DETAILS (state, payload) {
    for (let idx of payload.indexes) {
      if (idx >= 0) {
        Vue.delete(state.purchaseRequisition.details, idx)
      }
    }
  },
  SET_PURCHASE_REQUISITION (state, payload) {
    state.purchaseRequisition = payload.data
  },
  SET_MODAL_VISIBLE (state, payload) {
    state.isModalVisible = payload
  },
  SET_MODAL_PROP_VISIBLE (state, payload) {
    state.isModalPropVisible = payload
  },
  SET_FILTER_PARAMS (state, payload) {
    state.filterParams = payload
  },
  SET_CATALOG (state, { object, payload }) {
    state.purchaseRequisitionsCatalog[object] = payload.data
  }
}

const actions = {
  initPurchaseRequisition ({ commit }, payload) {
    commit('INIT_PURCHASE_REQUISITION_DETAIL', payload)
  },
  async loadPurchaseRequisitions ({ commit }, payload) {
    app.$Progress.start()
    try {
      const response = await axios.get(`purchase-requisitions?page=${payload.page}${state.filterParams}`)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'strings.purchase_requisitions', text: checkErrors.message }, { root: true })
      } else {
        commit('SET_PURCHASE_REQUISITIONS', response.data)
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
    }
  },
  async addPurchaseRequisition ({ commit }, payload) {
    const purchaseRequisition = {
      amount: parseFloat(payload.amount),
      user_id: parseInt(payload.user_id),
      details: payload.details

    }

    app.$Progress.start()

    try {
      const response = await axios.post('purchase-requisitions', purchaseRequisition)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'strings.purchase_requisitions', text: checkErrors.message }, { root: true })
      } else {
        commit('ADD_PURCHASE_REQUISITION', response.data)
        commit('SET_ACCEPT_ALERT', { color: 'success', title: 'strings.purchase_requisitions', text: 'front.added_successfully', icon: 'checkmark-circle-outline' }, { root: true })
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
    }
  },
  async editPurchaseRequisition ({ commit }, payload) {
    const purchaseRequisition = {
      amount: parseFloat(payload.amount),
      user_id: parseInt(payload.user_id),
      details: payload.details
    }

    app.$Progress.start()

    try {
      const response = await axios.put(`purchase-requisitions/${payload.id}`, purchaseRequisition)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'strings.purchase_requisitions', text: checkErrors.message }, { root: true })
      } else {
        commit('UPDATE_PURCHASE_REQUISITION', response.data)
        commit('SET_ACCEPT_ALERT', { color: 'success', title: 'strings.purchase_requisitions', text: 'front.updated_successfully', icon: 'checkmark-circle-outline' }, { root: true })
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
    }
  },
  async deletePurchaseRequisition ({ commit }, payload) {
    app.$Progress.start()
    try {
      const response = await axios.delete(`purchase-requisitions/${payload.id}`)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'strings.purchase_requisitions', text: checkErrors.message }, { root: true })
      } else {
        commit('DELETE_PURCHASE_REQUISITION', payload)
        commit('SET_ACCEPT_ALERT', { color: 'success', title: 'strings.purchase_requisitions', text: 'front.deleted_successfully', icon: 'checkmark-circle-outline' }, { root: true })
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
    }
  },
  async deletePurchaseRequisitions ({ commit }, payload) {
    app.$Progress.start()
    try {
      const response = await axios.delete(`purchase-requisitions/delete`, { params: { ids: payload.ids } })
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'strings.purchase_requisitions', text: checkErrors.message }, { root: true })
      } else {
        commit('DELETE_PURCHASE_REQUISITIONS', payload)
        commit('SET_ACCEPT_ALERT', { color: 'success', title: 'strings.purchase_requisitions', text: 'front.deleted_successfully', icon: 'checkmark-circle-outline' }, { root: true })
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
    }
  },
  async addPurchaseRequisitionDetail ({ commit }, payload) {
    app.$Progress.start()
    const PurchaseRequisitionDetail = {
      product: payload.product,
      quantity: parseInt(payload.quantity),
      unit_price: parseFloat(payload.unit_price),
      unit_measurement_id: parseInt(payload.unit_measurement.id),
      units_measurement: payload.unit_measurement,
      inventory_id: parseInt(payload.unit_measurement.id),
      inventory: payload.inventory
    }
    commit('ADD_PURCHASE_REQUISITION_DETAIL', PurchaseRequisitionDetail)
    commit('SET_MODAL_VISIBLE', false)
    app.$Progress.finish()
  },
  async editPurchaseRequisitionDetail ({ commit }, payload) {
    app.$Progress.start()
    const PurchaseRequisitionDetail = {
      id: payload.detail.id,
      product: payload.product,
      quantity: parseInt(payload.quantity),
      unit_price: parseFloat(payload.unit_price),
      unit_measurement_id: parseInt(payload.unit_measurement.id),
      units_measurement: payload.unit_measurement,
      inventory_id: parseInt(payload.unit_measurement.id),
      inventory: payload.inventory
    }
    commit('UPDATE_PURCHASE_REQUISITION_DETAIL', { payload: PurchaseRequisitionDetail, idx: payload.index })
    commit('SET_MODAL_VISIBLE', false)
    app.$Progress.finish()
  },
  async deletePurchaseRequisitionDetail ({ commit }, payload) {
    app.$Progress.start()
    commit('DELETE_PURCHASE_REQUISITION_DETAIL', payload.index)
    app.$Progress.finish()
  },
  async deletePurchaseRequisitionDetails ({ commit }, payload) {
    app.$Progress.start()
    commit('DELETE_PURCHASE_REQUISITION_DETAILS', payload)
    app.$Progress.finish()
  },
  async loadPurchaseRequisition ({ commit }, payload) {
    app.$Progress.start()
    try {
      const response = await axios.get(`purchase-requisitions/${payload.id}`)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'strings.purchase_requisitions', text: checkErrors.message }, { root: true })
      } else {
        commit('SET_PURCHASE_REQUISITION', response.data)
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
    }
  },
  async actionPurchaseRequisition ({ commit }, payload) {
    app.$Progress.start()
    try {
      const response = await axios.put(`purchase-requisitions/${payload.id}/${payload.action}`)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'strings.purchase_requisitions', text: checkErrors.message }, { root: true })
      } else {
        commit('UPDATE_PURCHASE_REQUISITION', response.data)
        commit('UPDATE_PURCHASE_REQUISITION_ACTION', response.data)
        commit('SET_ACCEPT_ALERT', { color: 'success', title: 'strings.purchase_requisitions', text: `purchase_requisitions.${payload.action}`, icon: 'checkmark-circle-outline' }, { root: true })
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
    }
  },
  printReport ({ commit }, payload) {
    app.$Progress.start()
    try {
      window.open(axios.defaults.baseURL + '/purchase-requisitions/export?' + state.filterParams)
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
    }
  },
  printReportRecord ({ commit }, payload) {
    app.$Progress.start()
    try {
      window.open(`${axios.defaults.baseURL}/purchase-requisitions/${payload.id}/export`)
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
    }
  },
  applyFilter ({ commit }, payload) {
    const filter = parserFilters(payload)
    commit('SET_FILTER_PARAMS', filter)
  },
  clearFilter ({ commit }, payload) {
    const filter = ''
    commit('SET_FILTER_PARAMS', filter)
  },
  async loadCatalog ({ commit }, payload) {
    let url = parserSlug(payload.url)
    app.$Progress.start()
    try {
      const response = await axios.get(`${url}${payload.filter}`)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'strings.purchase_requisitions', text: checkErrors.message }, { root: true })
      } else {
        commit('SET_CATALOG', { object: payload.url, payload: response.data })
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
    }
  },
  setModalVisible ({ commit }, payload) {
    commit('SET_MODAL_VISIBLE', payload)
  },
  setModalPropVisible ({ commit }, payload) {
    commit('SET_MODAL_PROP_VISIBLE', payload)
  },
  setModalImportVisible ({ commit }, payload) {
    commit('SET_MODAL_IMPORT_VISIBLE', payload, { root: true })
  }
}

const getters = {
  purchaseRequisition: state => state.purchaseRequisition,
  purchaseRequisitions: state => state.purchaseRequisitions,
  purchaseRequisitionsCatalog: state => state.purchaseRequisitionsCatalog,
  pagination: state => state.pagination,
  isModalVisible: state => state.isModalVisible,
  isModalPropVisible: state => state.isModalPropVisible,
  filterParams: state => state.filterParams
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
